import { createSlice } from "@reduxjs/toolkit";
import { logInSuccess, signOutSuccess } from "src/modules/auth/duck/actions";

const initialState = { byId: {}, library: [], defaultLullabyId: null };

const lullabySlice = createSlice({
  name: "lullaby",
  initialState,
  reducers: {
    saveLullaby(state, { payload }) {
      state.byId[payload.objectId] = payload;
    },
    deleteLullaby(state, { payload }) {
      delete state[payload];
    },
    replaceLullabies(state, { payload }) {
      state.byId = payload;
    },
    setLullabiesLibrary(state, { payload }) {
      state.library = payload;
    },
    setDefaultLullaby(state, { payload }) {
      state.defaultLullabyId = payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(logInSuccess, () => {
        return initialState;
      })
      .addCase(signOutSuccess, () => {
        return initialState;
      })
      .addMatcher(
        (action) =>
          action.type.endsWith("/deleteLullaby") ||
          action.type.endsWith("/replaceLullabies"),
        (state) => {
          if (state.byId[state.defaultLullabyId] == null) {
            state.defaultLullabyId = Object.values(state.byId)[0]?.objectId;
          }
        }
      );
  }
});

export { lullabySlice };
export default lullabySlice.reducer;
